<template>
  <div class="quick_sales">
    <div class="header">车家·Quick Sales</div>
    <!-- 搜索 -->
    <div class="search">
      <input type="text" class="search_ipt" placeholder="请输入ID" maxlength="50" v-model.trim="searchValue" />
      <button class="search_btn" @click="handleClickSearch">搜索</button>
    </div>

    <!-- 搜索结果 -->
    <div class="search_result" v-show="isUsers">
      <div class="search_result_title">搜索结果</div>
      <div class="search_result_info">
        <div class="user item_active">
          <div class="user_item">
            <div class="user_item_name"> 姓名：{{users.name}}</div>
            <div class="user_item_phone">手机号码：{{users.crmMobilenumberC}}</div>
          </div>
        </div>
        <div class="model item_active">车型：{{users.crmVehiclemodelC}}</div>
        <div class="city item_active">城市：{{users.crmTransactioncityC}}</div>
        <div class="user item_active">
          <div class="user_item">
            <div class="user_item_name"> 金编：{{users.crmErpidC}}</div>
            <div class="user_item_phone">车家额度：{{users.crmMybankAmtC}}</div>
          </div>
        </div>
        <div class="user item_active">
          <div class="user_item">
            <div class="user_item_name"> 金态：{{users.crmFinIdinputstatusC}}</div>
            <div class="user_item_phone">终审额度：{{users.crmCjCdtAmtC}}</div>
          </div>
        </div>
        <div class="sketch" v-show="isInfoShow">总记录：
          {{users.description}}
        </div>
        <div class="fold" @click="handleClickFold">
          {{isInfoShow ?  '收起':'总记录'}}
          <img v-show="!isInfoShow" src="../../assets/image/QuickSales/down.png" alt="" class="fold_img">
          <img v-show="isInfoShow" src="../../assets/image/QuickSales/up.png" alt="" class="fold_img">
        </div>
      </div>
    </div>

    <!--填报人 -->
    <div class="filled_by">
      <div class="search_result_title">填报人</div>
      <div class="filled_by_info click_item">
        <div class="filled_by_left"><span class="required">*</span> 填报人： </div>
        <div class="filled_by_right">
          <van-field readonly clickable :value="users.filledBy" placeholder="请选择" @click="showPickerFilledBy = true" />
          <van-popup v-model="showPickerFilledBy" round position="bottom">
            <van-picker show-toolbar :columns="columnsFilledBy" value-key="fullName" @cancel="showPickerFilledBy = false" @confirm="onConfirmFilledBy" />
          </van-popup>
          <img src="../../assets/image/QuickSales/down.png" alt="" class="sel_down">
        </div>
      </div>
    </div>

    <!--致电-->
    <div class="plan">
      <div class="plan_title">致电</div>
      <div class="item_info plan_info click_item">
        <div class="item_left">
          <span class="item_star">*</span> 致电(CRM):
        </div>
        <div class="item_right">
          <van-field readonly clickable :value="users.call" placeholder="请选择" @click="showPickerCall = true" />
          <van-popup v-model="showPickerCall" round position="bottom">
            <van-picker show-toolbar :columns="columnsCall" value-key="label" @cancel="showPickerCall = false" @confirm="onConfirmCall" />
          </van-popup>
          <img src="../../assets/image/QuickSales/down.png" alt="" class="sel_down">
        </div>
      </div>
    </div>

    <!-- 意向 -->
    <div class="plan">
      <div class="plan_title">意向</div>
      <!-- 购车意向(AM)-->
      <div class="contact_content">
        <div class="item_info click_item">
          <div class="item_left">
            <span class="item_star">*</span> 购车意向(AM):
          </div>
          <div class="item_right">
            <van-field readonly clickable :value="users.carIntention" placeholder="请选择" @click="showPickerCarIntention = true" />
            <van-popup v-model="showPickerCarIntention" round position="bottom">
              <van-picker show-toolbar :columns="columnsCarIntention" value-key="label" @cancel="showPickerCarIntention = false" @confirm="onConfirmCarIntention" />
            </van-popup>
            <img src="../../assets/image/QuickSales/down.png" alt="" class="sel_down">
          </div>
        </div>
      </div>
      <!-- 购车车型(AM): -->
      <div class="contact_content">
        <div class="item_info">
          <div class="item_left">
            <span class="item_star">*</span> 购车车型(AM):
          </div>
          <div class="item_right">
            <input type="text" placeholder="请填写" class="item_input" v-model.trim="users.crmVehpurchasetypeC" maxlength="50">
          </div>
        </div>
      </div>
      <!-- 购车时间(AM):-->
      <!-- <div class="contact_content">
        <div class="item_info click_item">
          <div class="item_left">
            <span class="item_star">*</span> 购车时间(AM):
          </div>
          <div class="item_right">
            <van-field readonly clickable :value="users.crmVehpurchasetimeC" placeholder="请选择" @click="showPickerTime = true" />
            <van-popup v-model="showPickerTime" round position="bottom">
              <van-datetime-picker v-model="purchaseTime.currentDate" type="date" :min-date="purchaseTime.minDate" :max-date="purchaseTime.maxDate" @cancel="showPickerTime = false" @confirm="onConfirmTime" class="datetime_picker" />
            </van-popup>
            <img src="../../assets/image/QuickSales/time.png" alt="" class="purchase_time" @click="showPickerTime = true">
          </div>
        </div>
      </div> -->
      <div class="contact_content">
        <div class="item_info click_item">
          <div class="item_left info_time">
            <span class="item_star">*</span> 购车时间(AM):
          </div>
          <div class="item_right data_picker">
            <el-date-picker v-model="users.crmVehpurchasetimeC" type="date" placeholder="请选择" value-format="yyyy-MM-dd" :editable="false">
            </el-date-picker>
            <img src="../../assets/image/QuickSales/time.png" alt="" class="purchase_time" @click="showPickerTime = true">
          </div>
        </div>
      </div>

      <!--高意向(M)： -->
      <div class="contact_content">
        <div class="item_info click_item">
          <div class="item_left QuickSales">
            <span class="item_star">*</span> QuickSales意向：
          </div>
          <div class="item_right">
            <van-field readonly clickable :value="users.quickSales" placeholder="请选择" @click="showPickerQuickSales = true" />
            <van-popup v-model="showPickerQuickSales" round position="bottom">
              <van-picker show-toolbar :columns="columnsQuickSales" value-key="label" @cancel="showPickerQuickSales = false" @confirm="onConfirmQuickSales" />
            </van-popup>
            <img src="../../assets/image/QuickSales/down.png" alt="" class="sel_down">
          </div>
        </div>
      </div>
    </div>

    <!--简述: -->
    <div class="sketch_info">
      <div class="sketch_title">
        <span class="item_star">*</span> 简述:
      </div>
      <div class="sketch_textarea">
        <van-field v-model.trim="users.crmSimpledescriptionC" rows="2" autosize type="textarea" maxlength="70" placeholder="请填写" show-word-limit class="sketch_text" />
      </div>
    </div>

    <!--联系-->
    <div class="plan">
      <div class="plan_title">联系</div>
      <!-- 新手机(AM)：-->
      <div class="item_info">
        <div class="item_left"> 新手机(AM)： </div>
        <div class="item_right">
          <input type="text" placeholder="请填写" class="item_input" maxlength="11" v-model.trim="users.crmUpdatedmobileC">
        </div>
      </div>
      <!--标记(HSQ)： -->
      <div class="item_info">
        <div class="item_left">标记(HSQ)： </div>
        <div class="item_right">
          <input type="text" placeholder="请填写" class="item_input" maxlength="10" v-model.trim="users.crmName1C">
        </div>
      </div>
      <!--微信(AM)：-->
      <div class="item_info" style="border:none;">
        <div class="item_left">微信(AM)： </div>
        <div class="item_right">
          <input type="text" placeholder="请填写" class="item_input weChat_input" maxlength="50" v-model.trim="users.crmWxaccountC">
          <div class="weChat" @click="handleClickSelect">
            <img v-show="crmWxismobC" src="../../assets/image/QuickSales/select.png" alt="" class="weChat_img">
            <img v-show="!crmWxismobC" src="../../assets/image/QuickSales/cancel.png" alt="" class="weChat_img">手机=微信
          </div>
        </div>
      </div>
    </div>

    <!--计划 -->
    <div class="plan">
      <div class="plan_title">计划</div>
      <!-- 购车意向(AM)-->
      <div class="contact_content">
        <div class="item_info click_item plan_txt">
          <div class="item_left"> 申关： </div>
          <div class="item_right">
            <van-field readonly clickable :value="users.planValue" placeholder="请选择" @click="showPickerPlan = true" />
            <van-popup v-model="showPickerPlan" round position="bottom">
              <van-picker show-toolbar :columns="planLists" value-key="label" @cancel="showPickerPlan = false" @confirm="onConfirmPlan" />
            </van-popup>
            <img src="../../assets/image/QuickSales/down.png" alt="" class="sel_down">
          </div>
        </div>
      </div>
    </div>

    <!-- 提交 -->
    <div class="submit">
      <button class="submit_btn" @click="submitInfo" :disabled="isDisabled">提交</button>
    </div>
  </div>
</template>

<script>
import qs from 'qs';
import { Toast } from 'vant';
export default {
  data() {
    return {
      isUsers: false,
      users: {}, //搜索结果
      searchValue: '', //搜索内容
      isInfoShow: false, //总记录/收起/简述默认隐藏
      columnsFilledBy: [], //填报人
      columnsCall: [], //致电
      columnsCarIntention: [], //购车意向
      columnsQuickSales: [], //QuickSales意向
      textareaInfo: '', //简述textarea
      isSelect: false, //手机/微信默认不选中
      showPickerTime: false, //购车时间/弹框默认不显示
      timeValue: '', //购车时间,
      showPickerFilledBy: false, //填报人
      showPickerCarIntention: false, //购车意向
      showPickerCall: false, //致电
      showPickerQuickSales: false, //QuickSales意向
      showPickerCall: false, //致电
      isDisabled: false, //禁止按钮
      crmWxismobC: false,
      showPickerPlan: false, //计划
      planLists: [
        { label: ' ', value: 1, disabled: false },
        { label: '是', value: 2 },
      ], //申关
    };
  },
  mounted() {
    const crmIdC = sessionStorage.getItem('searchValue');
    if (crmIdC) {
      this.searchValue = crmIdC;
      this.reqUsers(crmIdC); //获取搜索结果数据
    }

    this.reqTeleStatus(); //致电/意向
    this.reqVpIntention();
    this.reqHighIntention();
    this.reqFilledBy();
    this.reqUsers(crmIdC);
    this.crmQslatestsalesC1 = sessionStorage.getItem('crmQslatestsalesC');
    if (this.crmQslatestsalesC1) {
      this.users.filledBy = this.crmQslatestsalesC1;
    } else {
      this.users.filledBy = '';
    }
  },

  methods: {
    handleClickSearch() {
      if (!this.searchValue) return Toast('请输入id');
      this.reqUsers(this.searchValue);
    },
    // 购车时间选择
    onConfirmTime(value) {
      this.showPickerTime = false;
      let year = value.getFullYear();
      let month = value.getMonth() + 1;
      let day = value.getDate();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      this.users.crmVehpurchasetimeC = `${year}-${month}-${day}`;
    },
    // 填报人:
    onConfirmFilledBy(value) {
      this.users.createdBy = value.id;
      this.users.filledBy = value.fullName;
      this.showPickerFilledBy = false;
      sessionStorage.setItem('crmQslatestsalesC', value.fullName);
    },

    // 致电(CRM):
    onConfirmCall(val) {
      this.users.call = val.label;
      this.users.crmTelephonestatus1C = val.value;
      this.showPickerCall = false;
    },

    //QuickSales意向
    onConfirmQuickSales(val) {
      this.users.quickSales = val.label;
      this.users.crmQsintentionC = val.value;
      this.showPickerQuickSales = false;
    },

    // 购车意向(AM):
    onConfirmCarIntention(val) {
      this.users.carIntention = val.label;
      this.users.crmVpintentionC = val.value;
      this.showPickerCarIntention = false;
    },
    handleClickFold() {
      this.isInfoShow = !this.isInfoShow;
    },
    // 手机/微信选择状态
    handleClickSelect() {
      this.crmWxismobC = !this.crmWxismobC;
    },
    // 计划
    onConfirmPlan(val) {
      this.users.planValue = val.label;
      this.users.crmExctfeedbackC = val.value;
      this.showPickerPlan = false;
    },
    //提交表单数据
    async submitInfo() {
      let {
        idC,
        filledBy,
        call,
        carIntention,
        quickSales,
        createdBy,
        crmSimpledescriptionC,
        crmUpdatedmobileC,
        crmVehpurchasetimeC,
        crmVehpurchasetypeC,
        crmName1C,
        crmWxaccountC,
        crmTelephonestatus1C,
        crmVpintentionC,
        crmQsintentionC,
        crmExctfeedbackC,
      } = this.users;
      if (!this.searchValue) {
        return Toast('请输入ID');
      }
      if (!filledBy) {
        return Toast('请选择填报人信息');
      }
      if (!call) {
        return Toast('请选择致电(CRM)信息');
      }
      if (!carIntention) {
        return Toast('请选择购车意向(AM)信息');
      }
      if (!crmVehpurchasetypeC) {
        return Toast('请输入购车车型(AM)信息');
      }
      if (!crmVehpurchasetimeC) {
        return Toast('请选择购车时间(AM)信息');
      }
      if (!quickSales) {
        return Toast('请选择QuickSales意向信息');
      }
      if (!crmSimpledescriptionC) {
        return Toast('请输入简述信息');
      }
      if (crmUpdatedmobileC) {
        if (!/^(1[3,5,6,7,8,9][0-9])\d{8}$/.test(crmUpdatedmobileC)) {
          return Toast('请输入正确手机号');
        }
      }
      this.isDisabled = true;
      const crmWxismobC1 = this.crmWxismobC === false ? '0' : '1';
      if(createdBy == undefined || createdBy == null || createdBy == ''){
        const filledByList = this.columnsFilledBy.filter(item=>item.fullName == this.users.filledBy)
        createdBy = filledByList[0].id
      }
      const data = {
        idC,
        createdBy, //填报人id
        crmQslatestsalesC: filledBy, //填报人姓名
        crmTelephonestatus1C, //致电
        crmVpintentionC, //购车意向
        crmQsintentionC, //高意向
        crmVehpurchasetypeC, //购车车型
        crmVehpurchasetimeC, //购车时间
        crmSimpledescriptionC:
          crmSimpledescriptionC + '_' + this.users.filledBy, //简述:
        crmUpdatedmobileC, //新手机
        crmName1C, //标记
        crmWxaccountC, //微信
        crmWxismobC: crmWxismobC1, //微信状态
        crmExctfeedbackC: crmExctfeedbackC || '', //计划
      };
      try {
        const result = await this.$axios.post(
          'crm/quickSales/updateAccountsAudit',
           data

        );
        if (result.data.code === 0) {
          Toast(result.data.msg);
          setTimeout(() => {
            this.$router.push(`/quick_sales?filledBy=${this.users.filledBy}`);
          }, 1000);
        } else {
          Toast(result.data.msg);
          this.isDisabled = false;
        }
      } catch (error) {
        Toast(error.data.msg);
        this.isDisabled = false;
      }
    },
    // 获取用户信息
    async reqUsers(crmIdC) {
      try {
        const result = await this.$axios.post(
          '/crm/quickSales/queryAccounts',
          qs.stringify({ crmIdC: crmIdC })
        );
        if (result.data.code === 0) {
          if (result.data.data == null) {
            this.isUsers = false;
            Toast(result.data.msg);
            this.users = {};
            return;
          }
          this.isUsers = true;
          sessionStorage.setItem('searchValue', this.searchValue);
          const dataInfo = result.data.data;
          this.users = dataInfo;
          this.reqTeleStatus(); //致电/意向
          this.reqVpIntention();
          this.reqHighIntention();
          this.reqFilledBy();
          this.crmWxismobC = dataInfo.crmWxismobC;
          this.users.filledBy = this.crmQslatestsalesC1;
          if (this.users.crmExctfeedbackC == true) {
            this.users.planValue = '是';
            this.planLists[0].disabled = true;
          }
        } else {
          Toast(result.data.msg);
        }
      } catch (error) {
          Toast(error.data.msg);
      }
    },
    // 填报人
    async reqFilledBy() {
      try {
        const result = await this.$axios.post('/crm/quickSales/queryUsers');
        if (result.data.code === 0) {
          this.columnsFilledBy = result.data.data;

          let filledByList = this.columnsFilledBy.filter(
            (item) => item.fullName == this.users.filledBy
          );
          this.users.createdBy = filledByList[0].id;


        }
      } catch (error) {}
    },
    //致电信息
    async reqTeleStatus() {
      try {
        const resultCall = await this.$axios.get('admin/dict/type/tele_status'); //致电
        if (resultCall.data.code === 0) {
          this.columnsCall = resultCall.data.data;
          const res2 = this.columnsCall.filter(
            (item) => item.value == this.users.crmTelephonestatus1C
          );
          this.users.call = res2[0].label;
        } else {
          Toast(resultCall.data.msg);
        }
      } catch (error) {}
    },
    //购车意向
    async reqVpIntention() {
      try {
        const resultCarIntention = await this.$axios.get(
          'admin/dict/type/vp_intention'
        );
        if (resultCarIntention.data.code === 0) {
          this.columnsCarIntention = resultCarIntention.data.data;
          const res3 = this.columnsCarIntention.filter(
            (item) => item.value == this.users.crmVpintentionC
          );
          this.users.carIntention = res3[0].label;
        } else {
          Toast(resultCall.data.msg);
        }
      } catch (error) {}
    },
    //QuickSales意向：
    async reqHighIntention() {
      try {
        const resultQuickSales = await this.$axios.get(
          'admin/dict/type/high_intention'
        );
        if (resultQuickSales.data.code === 0) {
          this.columnsQuickSales = resultQuickSales.data.data;
          const res4 = this.columnsQuickSales.filter(
            (item) => item.value == Number(this.users.crmQsintentionC)
          );
          this.users.quickSales = res4[0].label;
        } else {
          Toast(resultCall.data.msg);
        }
      } catch (error) {}
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.van-cell {
  padding: 0;
  height: 100%;
  display: flex;
  align-items: center;
  .van-cell::after {
    border: none;
  }
  .van-field__value {
    .van-field__body {
      .van-field__control {
        font-size: 0.28rem !important;
        line-height: 0.4rem;
      }
    }
  }
}
/deep/ .van-popup--bottom {
  position: fixed;
  width: 7.5rem;
  left: 50%;
  margin-left: -3.75rem;
}

/deep/ .el-icon-date:before {
  content: '';
}
/deep/ .el-input {
  width: 4.43rem;
}
/deep/ .info_time .el-input--prefix .el-input__inner {
  padding: 0 !important;
}
/deep/.el-input__inner {
  border: none;
  padding-left: 0 !important;
  font-size: 0.28rem;
  color: #151515;
}
input::-webkit-input-placeholder {
  font-size: 0.28rem;
  color: #b8b8b8;
}

input::-moz-input-placeholder {
  font-size: 0.28rem;
  color: #b8b8b8;
}

input::-ms-input-placeholder {
  font-size: 0.28rem;
  color: #b8b8b8;
}
.search_btn:hover,
.click_item:hover,
.submit_btn:hover {
  cursor: pointer;
}

.quick_sales {
  margin: 0 auto;
  max-width: 7.5rem;
  box-shadow: 2px 2px 25px 0 rgba(0, 0, 0, 0.1);
  .header {
    font-size: 0.36rem;
    color: #222222;
    text-align: center;
    line-height: 0.88rem;
    height: 0.88rem;
    border-bottom: 0.01rem solid #f1f1f1;
    font-weight: 600;
  }

  // 搜索
  .search {
    margin: 0.19rem 0.35rem 0.39rem;
    display: flex;
    justify-content: space-between;
    .search_ipt {
      width: 4.98rem;
      height: 0.78rem;
      background: #fafdff;
      border: 0.01rem solid #3289ff;
      border-radius: 0.08rem;
      border-radius: 0.08rem;
      padding-left: 0.25rem;
      box-sizing: border-box;
      font-family: PingFangSC-Regular;
      font-size: 0.28rem;
      color: #333333;
      line-height: 0.26rem;
    }
    .search_btn {
      width: 1.62rem;
      height: 0.78rem;
      background: #3289ff;
      border-radius: 0.08rem;
      border-radius: 0.08rem;
      border: none;
      font-family: PingFangSC-Medium;
      font-size: 0.26rem;
      color: #ffffff;
      text-align: center;
      line-height: 0.38rem;
    }
  }
  .search_result_title {
    font-size: 0.24rem;
    color: #888888;
    margin-left: 0.35rem;
  }
  .search_result {
    .search_result_info {
      background: #eff5ff;
      border-radius: 0.08rem;
      border-radius: 0.08rem;
      width: 6.8rem;
      margin: 0.08rem 0.35rem 0.2rem;
      padding: 0.22rem 0.25rem;
      font-size: 0.26rem;
      color: #7b7f92;

      .user {
        display: flex;
      }
      .user_item {
        display: flex;
        flex-wrap: wrap;
        .user_item_name {
          margin-right: 0.31rem;
        }
        .user_item_phone {
          white-space: wrap !important;
        }
      }
      .user_left {
        margin-right: 0.31rem;
      }
      .user_right {
        white-space: wrap !important;
      }
      .user_left_name {
        display: flex;
        flex-wrap: wrap;
      }
      .QuickSales {
        width: 3.86rem;
      }
      .user_right {
        display: flex;
        margin-left: 0.31rem;
        white-space: wrap;
        flex-wrap: wrap;
      }
      .item_active {
        padding: 0.08rem 0;
      }
      .fold {
        margin-top: 0.15rem;
        height: 0.77rem;
        border-top: 0.01rem solid#D1DDF2;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.26rem;
        color: #9099bc;
        .fold_img {
          width: 0.2rem;
          height: 0.2rem;
          margin-left: 0.085rem;
        }
      }
    }
  }

  // 填报人
  .filled_by {
    .filled_by_info {
      height: 1.16rem;
      width: 6.8rem;
      background: #eff5ff;
      border-radius: 0.08rem;
      border-radius: 0.08rem;
      margin: 0.08rem 0.35rem 0.25rem;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      .filled_by_left {
        width: 2.37rem;
        padding-left: 0.25rem;
        box-sizing: border-box;
        font-size: 0.28rem;
        color: #151515;
      }
      .filled_by_right {
        width: 4.43rem;
        display: flex;
        padding-right: 0.25rem;
        box-sizing: border-box;
        height: 100%;
        align-items: center;
        font-size: 0.28rem;
        color: #333333;
        position: relative;
        margin-right: 0.25rem;
      }
      /deep/.van-cell {
        .van-field__value {
          .van-field__body {
            .van-field__control {
              height: 1.16rem;
              background: #eff5ff;
            }
          }
        }
      }
    }
  }
  .required {
    color: #c82a18;
    font-size: 0.28rem;
  }
  // title_item部分
  .title_item {
    height: 0.61rem;
    padding: 0.2rem 0 0 0.35rem;
    box-sizing: border-box;
    font-size: 0.24rem;
    color: #888888;
    background: #f4f4f4;
  }
  .sel_down {
    position: absolute;
    right: 0;
    pointer-events: none;
    width: 0.2rem;
    height: 0.2rem;
  }
  .purchase_time {
    position: absolute;
    right: 0;
    pointer-events: none;
    width: 0.3rem;
    height: 0.3rem;
  }
  // 致电
  .call_info {
    height: 1.16rem;
    justify-content: center;
    align-items: center;
    margin: 0 0.398rem 0 0.35rem;
    display: flex;
    border-bottom: 0.01rem solid #f1f1f1;
    /deep/.van-dropdown-menu__item {
      background: #fff;
      justify-content: start;
    }
    .call_name {
      width: 2.37rem;
    }
    .call_input {
      width: 4.4rem;
      height: 100%;
      border: none;
    }
  }

  //简述
  .sketch_info {
    margin: 0 0.35rem 0.34rem;
    /deep/.van-field__value {
      background: #f7f7f7;
    }
    /deep/.van-field__body {
      height: 1.51rem;
      border-radius: 0.08rem;
      border-radius: 0.08rem;
      .van-field__control {
        height: 100% !important;
      }
    }

    /deep/.van-field__word-limit {
      height: 0.37rem;
      font-size: 0.26rem;
      color: #b8b8b8;
    }
    .sketch_title {
      padding-top: 0.3rem;
      height: 0.86rem;
      font-size: 0.28rem;
      color: #151515;
      box-sizing: border-box;
    }
    .sketch_text {
      padding: 0.23rem 0.25rem 0.15rem;
      background: #f7f7f7;
      height: 2.26rem;
      box-sizing: border-box;
    }
  }

  //联系
  .contact {
    .contact_title {
      height: 1.03rem;
      padding: 0.58rem 0 0 0.35rem;
      box-sizing: border-box;
      font-size: 0.24rem;
      line-height: 0.33rem;
      color: #888888;
      background: #f4f4f4;
    }
  }

  .item_info {
    display: flex;
    flex: 1;
    height: 1rem;
    margin: 0 0.35rem;
    border-bottom: 0.01rem solid #f1f1f1;
    .item_left {
      width: 2.6rem;
      height: 100%;
      display: flex;
      align-items: center;
      font-size: 0.28rem;
      color: #151515;
      line-height: 0.4rem;
    }
    .info_time {
      width: 2.5rem !important;
    }
    .data_picker {
      position: relative;
      width: 4.43rem !important;
      padding-left: 0.13rem;
    }

    .item_right {
      display: flex;
      align-items: center;
      width: 4.43rem;
      height: 100%;
      flex-wrap: nowrap;
      position: relative;
      .item_input {
        display: flex;
        flex: 1;
        height: 100%;
        font-size: 0.28rem;
        color: #151515;
        border: none;
      }
      .weChat_input {
        width: 2rem;
        margin-right: 0.2rem;
      }
      .weChat {
        font-size: 0.2rem;
        color: #7b7f92;
        display: flex;
        align-items: center;
        .weChat_img {
          margin-right: 0.11rem;
          width: 0.28rem;
          height: 0.28rem;
        }
      }
    }
  }
  .item_star {
    color: #c82a18;
    // margin-right: 0.01rem;
  }
  //计划
  .plan {
    .plan_title {
      background: #f4f4f4;
      height: 0.65rem;
      font-size: 0.24rem;
      color: #888888;
      line-height: 0.65rem;
      padding-left: 0.35rem;
    }
    .plan_txt {
      border-bottom: none;
      height: 1.16rem;
    }
  }

  // 提交
  .submit {
    padding: 0.4rem 0.35rem;
    box-sizing: border-box;
    background: #f4f4f4;
    .submit_btn {
      width: 6.8rem;
      height: 0.9rem;
      background: #3289ff;
      border-radius: 0.08rem;
      border-radius: 0.08rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      font-size: 0.3rem;
      color: #ffffff;
    }
  }
  .plan_info {
    border-bottom: none;
    height: 1.16rem;
  }
  .del_line {
    border-bottom: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuickSales/QuickSalesInfo.vue